import { ComponentProps, useContext } from "react";
import { Switch } from "react-router";

import { ApiTokenContext } from "@/contexts/api-token/ApiContextWrapper";
import { SUPPORTED_ROUTES } from "@/utils/constants/routing";

import { TypeSafeRedirect, TypeSafeRoute } from "./TypeSafeRouting";

function LoggedInRoute({
  defaultTo,
  ...props
}: ComponentProps<typeof TypeSafeRoute> & {
  defaultTo: SUPPORTED_ROUTES;
  path: SUPPORTED_ROUTES;
}) {
  const { token } = useContext(ApiTokenContext);
  const isLoggedIn = Boolean(token);
  return (
    <Switch>
      {isLoggedIn && <TypeSafeRoute {...props} />}
      {!isLoggedIn && (
        <TypeSafeRedirect
          exact={props.exact ?? false}
          path={props.path}
          to={defaultTo}
        />
      )}
    </Switch>
  );
}

function LoggedOutRoute({
  defaultTo,
  ...props
}: ComponentProps<typeof TypeSafeRoute> & {
  defaultTo: SUPPORTED_ROUTES;
  path: SUPPORTED_ROUTES;
}) {
  const { token } = useContext(ApiTokenContext);
  const isLoggedIn = Boolean(token);
  return (
    <Switch>
      {!isLoggedIn && <TypeSafeRoute {...props} />}
      {isLoggedIn && (
        <TypeSafeRedirect
          exact={props.exact ?? false}
          path={props.path}
          to={defaultTo}
        />
      )}
    </Switch>
  );
}

export { LoggedInRoute, LoggedOutRoute };
